import React from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'

import NavigationItem from 'components_new/molecules/NavigationItem'

import { addRef } from 'utils/queryHandler'
import { Context } from 'types/GlobalUserEvents'
import { useTranslation } from 'language/translator'
import { ISelectEntity } from 'types/GlobalEntities'

interface Props {
  entity: ISelectEntity
  sx?: SxProps
}

const EntityMetrics = React.memo((props: Props) => {
  const { entity, sx } = props

  const { lang } = useTranslation()

  return (
    <Box sx={sx}>
      {entity.metrics.all.map((metric) => (
        <NavigationItem
          arrow={true}
          key={metric.id}
          item={{
            href: `/metrics/${metric.id}`,
            icon: {
              name: 'Metric'
            },
            title: metric.title[lang],
            search: addRef('', Context.FROM_ENTITY)
          }}
        />
      ))}
    </Box>
  )
})

export default EntityMetrics
